import * as React from 'react';
import { SVGProps } from 'react';

const FileIconJpgSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 34 40" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M32 0H2a2 2 0 0 0-2 2v36a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z" />
    <path
      opacity={0.6}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5 18H9v9.667L12 25l6 5 4-3 3 2.25V18H9.5ZM9 31.5v-2.167l3-2.81 5.906 4.797L22 28.25l3 2.25V32H9v-.5Zm-1-13V33h18V17H8v1.5Zm10 4a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1.5-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 6V5h-1v1h1Zm-1.1 6.91a.338.338 0 0 1-.25.09H11v1h1.46c.307 0 .557-.1.75-.3.193-.193.29-.46.29-.8V7h-2v1h1v4.7a.256.256 0 0 1-.1.21Zm2.9-5.67V7h-.8v7h1.01v-2h1.29c.58 0 1.007-.127 1.28-.38.28-.253.42-.66.42-1.22V8.6c0-.567-.137-.973-.41-1.22-.273-.253-.703-.38-1.29-.38h-.7c-.327 0-.593.08-.8.24Zm.36.94c.107-.12.27-.18.49-.18h.6c.247 0 .433.057.56.17.127.113.19.273.19.48v1.7c0 .207-.063.367-.19.48-.127.113-.313.17-.56.17h-1.24l-.01-2.45a.53.53 0 0 1 .16-.37ZM21.75 12c.293 0 .543-.067.75-.2v.2c0 1 0 1-1 1H20v1h2.5a1 1 0 0 0 1-1V7h-2.3c-.58 0-1.01.127-1.29.38-.273.253-.41.66-.41 1.22v1.8c0 .567.137.977.41 1.23.273.247.703.37 1.29.37h.55Zm.59-1.17c-.107.113-.27.17-.49.17h-.6c-.247 0-.433-.057-.56-.17-.127-.113-.19-.273-.19-.48v-1.7c0-.207.063-.367.19-.48.127-.113.313-.17.56-.17h1.25v2.45c0 .133-.053.26-.16.38Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconJpgSizeM;
